module.exports = __webpack_public_path__ + "static/media/Edit_contact.5420895c.svg";